import {useMutation, useQuery, useQueryClient, UseQueryResult} from "react-query";
import {
    getAllCentre, getCentreMe,
    getOneCentre,
    ModifyCentre,
    setLittParams,
    setMobParameters,
    setTypePaie, setTypePaiement
} from "./centre.services";

export const useGetAllCentre = ():UseQueryResult<Centre[], Error>=>{
    return useQuery<Centre[], Error>(["centres"], getAllCentre, {
        staleTime:6000,
        refetchOnWindowFocus:false
    })
}



export const useGetCentreActuel = (suspense=true):UseQueryResult<CentreComplet, Error>=>{
    return useQuery<CentreComplet, Error>(["centre_actuel"], ()=>getCentreMe(), {
        staleTime:60000*10,
        cacheTime:60000*15,
        refetchOnWindowFocus:false,
        suspense:suspense
    })
}

export const useModifyCentre = ()=>{
    const queryClient = useQueryClient();
    return useMutation(
        (datas:ParamsPutCentre)=>{
            return ModifyCentre(datas)
        }, {
            onSuccess:()=>{
                queryClient.invalidateQueries(["centre_actuel"])
                queryClient.invalidateQueries(["centre"])
                queryClient.invalidateQueries(["centres"])
            }
        }
    )
}

export const useGetOneCentre = (id:number|undefined, suspense=true):UseQueryResult<CentreComplet, Error>=>{
    return useQuery<CentreComplet, Error>(["centre", id], ()=>getOneCentre(id ||-1), {
        staleTime:6000,
        refetchOnWindowFocus:false,
        enabled:id!==undefined && id>0,
        suspense:suspense
    })
}

export const useSetLitts = ()=>{
    const queryClient = useQueryClient();
    return useMutation(
        (data:{idCentre:number, litt:any})=>{
            return setLittParams(data.idCentre, data.litt);
        }, {
            onSuccess:()=>{
                queryClient.invalidateQueries(["centre"]);
                queryClient.invalidateQueries(["centres"]);
                queryClient.invalidateQueries(["centre_actuel"]);
            }
        }
    )
}

export const useSetMobParameters = ()=>{
    const queryClient = useQueryClient();
    return useMutation(
        (data:{idCentre:number, params:any})=>{
            return setMobParameters(data.idCentre, data.params);
        }, {
            onSuccess:()=>{
                queryClient.invalidateQueries(["centre"]);
                queryClient.invalidateQueries(["centres"]);
                queryClient.invalidateQueries(["user_connected"]);
                queryClient.invalidateQueries(["user_real"]);
                queryClient.invalidateQueries(["users"]);
                queryClient.invalidateQueries(["user"]);
            }
        }
    )
}

export const useSetTypePaie = ()=>{
    const queryClient = useQueryClient();
    return useMutation(
        (data:{idCentre:number, idTypePaie:number})=>{
            return setTypePaie(data.idCentre, data.idTypePaie);
        }, {
            onSuccess:()=>{
                queryClient.invalidateQueries(["centre"]);
                queryClient.invalidateQueries(["centres"]);
            }
        }
    )
}

export const useSetTypePaiement = ()=>{
    const queryClient = useQueryClient();
    return useMutation(
        (data:{idCentre:number, TypePaiement:string})=>{
            return setTypePaiement(data.idCentre, data.TypePaiement);
        }, {
            onSuccess:()=>{
                queryClient.invalidateQueries(["centre"]);
                queryClient.invalidateQueries(["centres"]);
                queryClient.invalidateQueries(["centre_actuel"]);
            }
        }
    )
}
